import styled, { css } from 'styled-components'
import {
  flexDirection,
  FlexDirectionProps,
  padding,
  PaddingProps,
} from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { LANDING_CONTENT_WIDTH_PX } from 'Constants/Landing'

import { gap, GapProps } from 'Services/Styles'

type ContainerProps = PaddingProps &
  GapProps & {
    secondary?: boolean
  }

const shouldForwardProp = (prop: string) =>
  !['secondary', 'flexDirection'].includes(prop)

const containerSecondaryCss = ({ secondary }: ContainerProps) =>
  secondary &&
  css`
    background-color: ${themeGet('colors.background.screenAlt')};
  `

export const Container = styled.div.withConfig({
  shouldForwardProp,
})<ContainerProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  overflow: hidden;

  ${padding}
  ${gap}

  ${containerSecondaryCss}
`

export const Content = styled.div.withConfig({
  shouldForwardProp,
})<FlexDirectionProps & PaddingProps & GapProps>`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: ${LANDING_CONTENT_WIDTH_PX}px;

  ${flexDirection}
  ${padding}
  ${gap}
`
